import React, { useEffect, useRef, useState } from 'react';
import DeleteModal from '../Calendar/DeleteModal';
import { useToast } from 'src/components/Common/ReactToaster';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrorMessage, deleteDealerSubuserLoading, getDealerSubuserListLoading, resetDealerSubuser } from 'src/store/dealersubuser/action';
import { Columns, LazyTableState } from 'src/models/components/dataTableWrapperModel';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import ArchiveModal from "../Calendar/DeleteModal";
import CustomizeTable from 'src/components/Common/CustomizeTable/CustomizeTable';
import ColumnAction from 'src/components/Common/ColumnAction/ColumnAction';
import { useNavigate } from 'react-router';
import { ROUTER } from 'src/constants/routes';
import EmailBodyTemplate from 'src/components/Common/EmailBodyTemplate/EmailBodyTemplate';
import { Form, Formik } from 'formik';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import Select from 'src/components/Common/Select';
import { Option } from 'src/models/components/inputWrapperModel';
import DataTableWrapper from 'src/components/Grid/DataTableWrapper';
import TooltipMEL from 'src/components/UI/Tooltip';
import { RootReducerState } from 'src/store/reducers';
import FeatherIcon from "feather-icons-react";
import { AnimatePresence, motion } from "framer-motion";
import { BUTTON_VARIANT } from 'src/constants/bulkActionVariant';
import BulkActionStatus from 'src/components/Common/BulkActionStatus/BulkActionStatus';
import { Dropdown } from 'primereact/dropdown';
import FilterIcon from 'src/components/Common/CustomFilterandSortIcon/FilterIcon';
import SortIcon from 'src/components/Common/CustomFilterandSortIcon/SortIcon';
import StatusHghlighter from 'src/components/Common/StatusHighlighter/StatusHighlighter';
import useFetchDataAndCheckRoles from 'src/helpers/getUserRole';
import ExportFile from 'src/components/Common/ExcelPdf Export/ExportFile';
import { hasDealerRoleHandler, saveAsExcelFile } from 'src/helpers/common_helpers';
import { ACTIVE, ALL, DELETED } from 'src/constants/commonConstants';
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup';
import { API } from 'src/util/api';
import { customizeTableColumns } from 'src/models/components/CustomizeTableColumns';

interface DealerProps {
  DealerId?: any;
  formValue?: any;
  isOnCreatePage?: boolean;
}

const DealerSubUserList = ({ DealerId, formValue, isOnCreatePage }: DealerProps) => {
  
  const isDealerLogin = hasDealerRoleHandler()
  // if (formValue) {
  //   localStorage.setItem('formvalues', JSON.stringify(formValue));
  // }
  const localData: any = localStorage.getItem("formvalues")
  const formattedData = JSON.parse(localData);
  
  const filterDetails: DataTableFilterMeta = {
    userName: { value: "", matchMode: "contains" },
    name: { value: "", matchMode: "contains" },
    email: { value: "", matchMode: "contains" },
    phoneNumber: { value: "", matchMode: "contains" },
    DealerId: { value: DealerId ? DealerId : formattedData?.id, matchMode: "contains" },
    isDeleted: { value: "false", matchMode: "contains" }
  };

  let initialLazyState: LazyTableState = {
    first: 0,
    rows: 10,
    page: 1,
    // sortField: "userName",
    // sortOrder: 1,
    sortField: "CreationTime",
    sortOrder: -1,
    filters: filterDetails,
  };

  const initialValues = {
    status: "",
  };


  //
  const statusBodyTemplate = (rowData: any, field: string) => {
    let status = rowData[field];
    return (
      <StatusHghlighter status={status} />
    );

  };

  const phoneVerifiedTemplate =(rowData:any) => {
    return(
      <div className="d-flex gap-1 align-items-center">
      <b>{rowData.phoneNumber}</b>
      {rowData.phoneNumberConfirmed ? <FeatherIcon icon="check-circle" className={`icon-lg right-icon`} style={{ color:"green",width:"20px"}}/>:null}
      </div>
    )
  }

  //table column
  const columns: Columns[] = [
    {
      field: "select",
      sortable: false,
      header: "",
      filter: false,
      showFilterMenu: false,
      frozen : true,
      selectionMode: "multiple",
      headerStyle: { width: "3rem", whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: true,
    },
    {
      field: "userName",
      sortable: true,
      header: "User Name",
      filter: true,
      frozen : true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "250px" },
      body: (rowData) => actionBodyTemplate(rowData, "userName"),
      isDefault: true,
      isStatic: true,
    },

    {
      field: "name",
      sortable: true,
      header: "Name",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", width: "200px", marginLeft: "20px" },
      isDefault: true,
      isStatic: false,
    },
    {
      field: "email",
      sortable: true,
      header: "Email",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap", minWidth: "300px" },
      isDefault: true,
      body: (rowData) => emailBodyTemplate(rowData, "email"),
      isStatic: false,
    },
    {
      field: "phoneNumber",
      sortable: true,
      header: "Mobile",
      filter: true,
      showFilterMenu: true,
      headerStyle: { whiteSpace: "nowrap" },
      body:(rowData:any)=>phoneVerifiedTemplate(rowData),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "alternateNumber",
      sortable: false,
      header: "Alternate Mobile Number",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: false,
      isStatic: false,
    },
    {
      field: "isActive",
      sortable: true,
      header: "Is Active",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => statusBodyTemplate(rowData, 'isActive'),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "sendSms",
      sortable: true,
      header: "Send Sms",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => statusBodyTemplate(rowData, 'sendSms'),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "sendEmail",
      sortable: true,
      header: "Send Email",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => statusBodyTemplate(rowData, 'sendEmail'),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "sendWhatsapp",
      sortable: true,
      header: "Send Whatsapp",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => statusBodyTemplate(rowData, 'sendWhatsapp'),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "lockoutEnabled",
      sortable: true,
      header: "Lockout Enabled",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      body: (rowData) => statusBodyTemplate(rowData, 'lockoutEnabled'),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "address",
      sortable: false,
      header: "Address",
      filter: false,
      showFilterMenu: false,
      headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
  ];

  const [selectedDealerSubuser, setSelectedDealerSubuser] = useState<any>([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [archiveModal, setArchiveModal] = useState(false);
  const [selectedStatus, setselectedStatus] = useState(ACTIVE);
  const [showCustomizeTable, setShowCustomizeTable] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);
  const [filter, setFilter] = useState(false);
  const [lazyState, setLazyState] = useState(initialLazyState);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [rowData, setRowData] = useState<any | null>(null);
  const [visibleColumns, setVisibleColumns] = useState(columns.filter((eachColumn: Columns) => eachColumn.isDefault));
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dt = useRef<DataTable<any>>(null);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  const { values, totalCount } = useSelector((state: RootReducerState) => state.dealerSubUserReducer.dealerSubUserList);
  
  const { loading, paginatorCount, error, message } = useSelector((state: RootReducerState) => state.dealerSubUserReducer);
  const[pdfLoading,setPdfLoading]=useState<boolean>(false)

  const url = process.env.REACT_APP_API_CONFIGURATION + "/api/abp/application-configuration";;
  const token = localStorage.getItem("token");
  const hasAdminOrEmployeeRole = useFetchDataAndCheckRoles(url, token);
  // const hasAdminOrEmployeeRole = localStorage.getItem("role");
  // console.log(hasAdminOrEmployeeRole)

  //bulkaction click
  const bulkActionClickHandler = () => {
    if (values.length > 0) {
      setSelectAll(true);
      setSelectedDealerSubuser(values);
    }
  };

  //cancel bulk option
  const cancelBulkActionHadler = () => {
    setSelectAll(false);
    setSelectedDealerSubuser([]);
  };

  const onCreateClickHandler = () => {
    navigate(ROUTER.DEALER_SUB_USER_CREATE);
  };

  const customizeTableClickHandler = () => {
    setShowCustomizeTable(true);
  };

  //dropdown option
  const options: Option[] = [
    { label: "All", value: "All" },
    { label: "Active", value: "Active" },
    { label: "Deleted", value: "Deleted" },
  ];
  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading||pdfLoading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading,pdfLoading]);

  const changeColumnDetails = (values: any[]) => {
    let modifiedColumnDetails = values.map((a) => {
      const { id, name: Name, email: Email, phoneNumber: Phone, address: Address, isActive: IsActive,sendSms,sendEmail,sendWhatsapp,phoneNumberConfirmed,alternateNumber } = a;
      let data:any={};
      data['Alternate Mobile Number']=alternateNumber;
      data['Send Sms']=sendSms;
      data['Send Email']=sendEmail;
      data['Send Whatsapp']=sendWhatsapp;
      data['Mobile Number Verified']=phoneNumberConfirmed;

      return { ...{ Name, Email, Phone, Address, IsActive },...data};
    });
    return modifiedColumnDetails;
  };

  const saveDataAsExcel = async (values: any[], fileName: string) => {
    let modifiedColumnDetails = await changeColumnDetails(values);
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(modifiedColumnDetails);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      saveAsExcelFile(excelBuffer, fileName);
    });
  };
  const fetchData = async (isPdf:boolean) => {
    let lazy:any= {
      ...lazyState,
      rows:totalCount>5000 ? 5000 : totalCount<1 ? 1 : totalCount,
      first:0,
      filters: {
        ...lazyState.filters,
      },
    };
	
    try {
      setPdfLoading(true)
      const response = await API.getDealerSubUserListAPI(lazy);
      if (!response) {
        throw new Error('Network response was not ok');
      }
     if(isPdf){

       saveDataAsPdf(response?.data?.items, columns, "Dealer SubUser");
     }else{
      saveDataAsExcel(response?.data?.items, "Dealer SubUser");
     }
     setPdfLoading(false)
    } catch (error:any) {
	  showToast(error.message,{type:"error"})
      setPdfLoading(false)
      
    } finally {
      setPdfLoading(false)
    }
  };
  const csvClickHandler = () => {
    // saveDataAsExcel(values, "Dealer_SubUser");
    fetchData(false)
  };

  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (error) {
      setVisible(true);
    }
    if (message) {
      showToast(message, { type: "success" });
      dispatch(clearErrorMessage())
    }
  }, [error, message]);

  const hidePopup = () => {
    setVisible(false);
    dispatch(clearErrorMessage());
  };

  const dialogContainer = (error: any) => {
    return (
      <>
        <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    );
  };

  const saveDataAsPdf = (values: any[], columns: any[], fileName: string) => {
    const destructureedData = values.map((data) => {
      let datas = {
        id: data.id,
        userName: data?.userName,
        name: data?.name,
        email: data?.email,
        phoneNumber: data?.phoneNumber,
        alternateNumber: data?.alternateNumber,
        phoneNumberConfirmed:data?.phoneNumberConfirmed,
        isActive: data?.isActive,
        sendSms:data?.sendSms,
        sendEmail:data?.sendEmail,
        sendWhatsapp:data?.sendWhatsapp,
        lockoutEnabled: data?.lockoutEnabled,
        address: data?.address
      };
      return datas;
    });
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const exportColumns = columns.map((col) => ({
          title: col.header,
          dataKey: col.field,
          styles: {
            cellPadding: 2,
            halign: 'center',
          },
          columnStyles: {
            address: { cellWidth: "40px" },
          },
        }));
        let columnsWithVerified=[...exportColumns,{
          title:"Mobile Number Verified",
          dataKey:"phoneNumberConfirmed",
          styles: {
            cellPadding: 2,
            halign: 'center',
          },
          columnStyles: {
            address: { cellWidth: "40px" },
          },

        }]
        const doc = new (jsPDF as any).default({
          orientation: 'landscape',
          format: 'a3',
        });
        doc.autoTable(columnsWithVerified, destructureedData);
        doc.save(`${fileName}.pdf`);
      });
    });
  };

  const pdfClickHandler = () => {
    // saveDataAsPdf(values, columns, "Dealer SubUser");
    fetchData(true)
  };
  const clearFilter=()=>{
    setLazyState(initialLazyState)
    setselectedStatus(ACTIVE)
  }

  //table headeer potion
  const header =
    <div className="table-header-container">
      <div>
        Dealer Subusers List
      </div>
      <div className="table-header-container-item table-header-container-item-special">
        {selectedDealerSubuser.length == 0 && <Button type="button" className="customize-table-button mr-1 " onClick={bulkActionClickHandler}>
          <FeatherIcon icon="layers" className="mr-1" />
          Bulk actions
        </Button>}
        <AnimatePresence>
          {selectedDealerSubuser.length > 0 &&
            <>
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                <Button type="button" className="secondary-btn  mr-1 delete-space" onClick={() => { setDeleteModal(true); }}>
                  {/* <FeatherIcon icon="trash-2" className="mr-1" /> */}
                  {/* {selectedStatus == DELETED ? "Restore" : "Delete"} */}
                  {selectedStatus == DELETED ? <><i className="fa fa-undo option-icons special"></i> <span className="remove_lables">Restore</span></> : <><FeatherIcon    icon="trash-2" className="mr-1" /> <span className="remove_lables">Delete</span></> }
                </Button>
              </motion.div>
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                <Button type="button" className="customize-table-button mr-1 ml-1" onClick={cancelBulkActionHadler} > <FeatherIcon icon="x" className="" /> Cancel selection</Button>
              </motion.div>
              <motion.div initial="initial" animate="animate" exit="exit" variants={BUTTON_VARIANT}>
                {selectedDealerSubuser.length > 0 && <BulkActionStatus count={selectedDealerSubuser.length} title="SubUsers"></BulkActionStatus>}
              </motion.div>
            </>
          }
        </AnimatePresence>

      </div>
      <div className="flex-grow-1"></div>
      <div className="table-header-container-item">
        <ExportFile exportExcel={csvClickHandler} exportPdf={pdfClickHandler} clearFilter={clearFilter} isFilter={true}/>
        <TooltipMEL title="Select Status" position="bottom" tooltipVisible={isTooltipVisible} setTooltipVisible={setIsTooltipVisible}>
          <Dropdown value={selectedStatus} onChange={(e) => handleSubmit(e.value)} options={options} optionLabel="label" placeholder="Select status .."
            filter className="w-full md:w-14rem" />
        </TooltipMEL>
        <Button type="button" className="customize-table-button mr-1 ml-1" id="ScheduleUpdateTooltip"
          onMouseEnter={() => setTooltipOpen(true)}
          onMouseLeave={() => setTooltipOpen(false)} data-btn="btn" onClick={customizeTableClickHandler}>
          <FeatherIcon icon="sliders" className="mr-1" />
        </Button>

        {!hasAdminOrEmployeeRole && !isOnCreatePage && !DealerId &&
          <Button type="button" className="btn btn-primary" onClick={onCreateClickHandler}>
            <FeatherIcon icon="plus-circle" className={"feathet-icon"} />
            Add Dealer SubUser
          </Button>
        }

        <UncontrolledTooltip
          placement="bottom"
          target="ScheduleUpdateTooltip"
          isOpen={tooltipOpen}
          toggle={toggleTooltip}
          innerClassName="tooltip-color"
        >
          Choose fields you want to see in the table
        </UncontrolledTooltip>
      </div>

    </div>;

  const onSort = (event: any) => {
    setLazyState(event);
    setSelectAll(false);
    setSelectedDealerSubuser([]);
  };

  const onFilter = (event: any) => {
    event["first"] = 0;
    setLazyState(event);
  };

  const onPage = (event: any) => {
    setLazyState(event);
  };


  //handle submit 
  const handleSubmit = (formValue: any) => {
    setselectedStatus(formValue);
    if (formValue == ACTIVE) {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          isDeleted: { value: "false", matchMode: "contains" },
        },
      }));
    }else if (formValue == ALL) {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          isDeleted: { value: null, matchMode: "contains" },
        },
      }));
    }
    else if (formValue == DELETED) {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          isDeleted: { value: "true", matchMode: "contains" },
        },
      }));
    }
    else {
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          isDeleted: { value: null, matchMode: "contains" },
        },
      }));
    }
    setIsTooltipVisible(false)
  };

  //handle reset
  const handleReset = (formValue: any) => {
    setLazyState((state) => ({
      ...state,
      filters: {
        ...state.filters,
        status: {
          ...state.filters.status,
          value: "",
        }
      },
    }));
  };

  //archive handler
  const archiveHandler = () => {
    setSelectAll(false);
    setSelectedDealerSubuser([]);
    setArchiveModal(false);
  };

  //customize table
  const customizeTableCancelHandler = () => {
    setShowCustomizeTable(false);
  };


  // const viewHandler = (rowData: subUser) => {
  const viewHandler = (rowData: any) => {
    if(!isDealerLogin){
      navigate(`${ROUTER.DEALER_SUB_USER_VIEW}/${rowData["id"]}/${DealerId}`);
    }else{
      navigate(`${ROUTER.DEALER_SUB_USER_VIEW}/${rowData["id"]}`);
    }
  };

  // const editHandler = (rowData: subUser) => {
  const editHandler = (rowData: any) => {
    navigate(`${ROUTER.DEALER_SUB_USER_EDIT}/${rowData["id"]}`);
  };

  // const deleteHandler = (rowData: subUser) => {
  const deleteHandler = (rowData: any) => {
    setDeleteModal(true);
    setRowData(rowData);
  };

  //true false boolean custom design 
  // const actionBodyTemplate = (rowData: subUser, field: string) => {
  const actionBodyTemplate = (rowData: any, field: string) => {

    
    
    return (
      // <ColumnAction
      //   displayData={rowData[field] as string}
      //   isEdit={true}
      //   isDelete={true}
      //   isView={true}
      //   onViewClick={() => viewHandler(rowData)}
      //   onEditClick={() => editHandler(rowData)}
      //   onDeleteClick={() => deleteHandler(rowData)}
      // />
      <>
        {
          rowData.isDeleted == false ? (
            <ColumnAction
              displayData={rowData[field] as string}
              isEdit={true}
              isDelete={true}
              isView={true}
              dealerSubUser={false}
              onViewClick={() => viewHandler(rowData)}
              onEditClick={() => editHandler(rowData)}
              onDeleteClick={() => deleteHandler(rowData)}              
            />
          ) : (
            <ColumnAction
              displayData={rowData[field] as string}
              undo={rowData.isDeleted ? true : false}
              onDeleteClick={() => deleteHandler(rowData)}
            />
          )
        }
      </>
    );
  };

  //customize table column
  const customizeTableColumns: customizeTableColumns[] = columns.map((eachColumns: Columns) => {
    let data: any = {};
    data['field'] = eachColumns.field;
    data['value'] = visibleColumns.some((sCol: any) => sCol.field === eachColumns.field);
    data['isDisable'] = eachColumns.isStatic;
    data['header'] = eachColumns.header;
    return data;
  }).filter((eachColumns: customizeTableColumns) => eachColumns.field != 'select');

  //email response custom design
  // const emailBodyTemplate = (rowData: subUser, field: string) => {
  // const emailBodyTemplate = (rowData: subUser, field: string) => {
  const emailBodyTemplate = (rowData: any, field: string) => {
    let data = rowData[field];
    return (
      <EmailBodyTemplate data={data} />
    );
  };

  const onSelectAllChange = (event: any) => {
    const selectAll = event.checked;
    if (selectAll) {
      setSelectAll(true);
      setSelectedDealerSubuser(values);
    } else {
      setSelectAll(false);
      setSelectedDealerSubuser([]);
    }
  };


  const defaultColumns = {
    ...columns[0]
  };

  const customizeColumnSubmitHandler = (customizeColumnObject: any[]) => {
    let orderedSelectedColumns = columns.filter((col) => customizeColumnObject.some((sCol: any) => sCol === col.field));

    setVisibleColumns([{ ...defaultColumns }, ...orderedSelectedColumns]);
    setShowCustomizeTable(false);
  };

  const onSelectionChange = (event: any) => {
    const value = event.value;
    setSelectedDealerSubuser(value);
    setSelectAll(value.length === paginatorCount);
  };

  //delete dealerSubUser
  const handleDeleteUsers = (rowData: any, length: number = 0, index: number = 0) => {
    let payload = {
      id: rowData["id"] ? rowData["id"] : rowData[0]?.id,
      undo: rowData['isDeleted'] ? true : (rowData[0]?.isDeleted ? true : false),
      lazyState,
    };
    dispatch(deleteDealerSubuserLoading(payload));
    setDeleteModal(false);
    setRowData(null);
    if (index + 1 === length || index === length) {
      setTimeout(() => {
        dispatch(getDealerSubuserListLoading(lazyState));
      }, 500);
      setSelectAll(false);
      setSelectedDealerSubuser([]);

    }
  };

  //call api

  const callbackFunction = (lazyState: LazyTableState) => {
    dispatch(getDealerSubuserListLoading(lazyState));
  };

  useEffect(() => {
    callbackFunction(lazyState);
  }, [lazyState, DealerId]);

  const [subUserPage,setSubUserPage]=useState<boolean>(true)
  const currentUrl = window.location.href;
  const res=currentUrl.split('/')

  useEffect(()=>{
    if(`/${res[res.length-1]}`==ROUTER.DEALER_SUB_USER_GRID){
      setSubUserPage(true)
    }else{
      setSubUserPage(false)
    }
  },[currentUrl]) 
  
  useEffect(()=>{
    return ()=>{
      dispatch(resetDealerSubuser())
    }
  },[])




  return (
    <React.Fragment>
      {/* <div className="page-content"> */}
      <div className={!subUserPage ? "" : "page-content"}>
        {/* {visible && dialogContainer(error)} */}
        {visible && dialogContainer(error)}
        <DeleteModal
          show={deleteModal}
          undo={selectedStatus == DELETED ? true : false}
          onDeleteClick={() => {
            if (selectedDealerSubuser?.length > 10) {
              showToast("Cannot delete more than 10 items at once", { type: "error" });
              setSelectedDealerSubuser([]);
              setDeleteModal(false);
              setSelectAll(false);
              return setRowData(null);
            }

            if (rowData || selectedDealerSubuser.length == 1) {
              handleDeleteUsers(rowData || selectedDealerSubuser);
            } else if (selectedDealerSubuser.length > 1) {
              for (let i = 0; i < selectedDealerSubuser.length; i++) {
                handleDeleteUsers(selectedDealerSubuser[i], selectedDealerSubuser.length, i);
              }
            }
          }}
          onCloseClick={() => {
            setDeleteModal(false);
            setRowData(null);
          }}
        />
        <ArchiveModal
          show={archiveModal}
          message="you want to archieve these administrators?"
          deleteLabel="Yes"
          closeLabel="No"
          onDeleteClick={() => {
            archiveHandler();
          }}
          onCloseClick={() => {
            setArchiveModal(false);
            setSelectAll(false);
            setSelectedDealerSubuser([]);
          }}
        />

        {showCustomizeTable && <CustomizeTable onCancelHandler={customizeTableCancelHandler} onCustomizeColumnSubmitHandler={customizeColumnSubmitHandler} columns={customizeTableColumns} />}


        {filter && (
          <div className="card">
            <div className="card-body">
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                onReset={handleReset}
                enableReinitialize
              >
                {({ values, handleChange }) => {
                  return (
                    <Form onChange={handleChange}>
                      <Row>
                        <Col xs={12} lg={7} id="export-search-clear">

                        </Col>
                        <Col xs={12} lg={5} id="export-search-clear d-flex">
                          <Select
                            label=""
                            name="status"
                            value={values.status}
                            onChange={handleChange}
                            options={options}
                            invalid={false}
                          />
                          <Button className="btn btn-primary ms-2" color="primary" type="reset">
                            Clear </Button>
                          <Button className="btn btn-primary ms-2" color="primary" type="submit">
                            Search </Button>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        )}
        <DataTableWrapper
          ref={dt}
          columnDetails={selectedStatus == "All" ? [...visibleColumns]?.filter((items: any) => items.field != "select") : visibleColumns}
          header={header}
          filterIcon={FilterIcon}
          sortIcon={(setOrder) => <SortIcon order={setOrder} />}
          value={values}
          lazy
          paginator={true}
          stripedRows={true}
          rowHover={true}
          // filterDisplay="row"
          rowsPerPageOptions={[5, 10, 25, 50]}
          totalRecords={totalCount}
          loading={loading}
          emptyMessage="No details found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Displaying dealer subuser   {last} records of {totalRecords} in total"
          selection={selectedDealerSubuser}
          onSelectionChange={onSelectionChange}
          selectAll={selectAll}
          onSelectAllChange={onSelectAllChange}
          first={lazyState.first}
          onSort={onSort}
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          onFilter={onFilter}
          filters={lazyState.filters}
          onPage={onPage}
          rows={lazyState.rows}
        >
        </DataTableWrapper>
      </div>
    </React.Fragment>
  )
}

export default DealerSubUserList